import { Field, useFormikContext } from "formik";
import React from "react";
import DatePicker from "react-datepicker";
import InputDatePicker from "./InputDatePicker";

const View = ({
  name,
  validate,
  fast,
  placeholder = "",
  format = "default",
  dark = false,
  required,
}: any) => {
  const ref: any = React.useRef({});
  const form = useFormikContext();

  const [date, $date] = React.useState(null);
  const handler = {
    onChange: (e: any) => {
      form.setFieldValue(name, e);
      $date(e);
    },
  };
  return (
    <Field name={name} validate={validate} fast={fast}>
      {({ field, form, meta }: any) => {
        ref.current.form = form;
        return (
          <DatePicker
            popperClassName="pb-popper"
            selected={date}
            placeholderText={placeholder}
            customInput={
              <InputDatePicker
                dark={dark}
                field={field}
                date={date}
                format={format}
                placeholder={placeholder}
                required={required}
                meta={meta}
              />
            }
            onChange={handler.onChange}
          />
        );
      }}
    </Field>
  );
};

export default View;
